import { useEffect } from 'react';
import overrideActions from '../../actions/overrides';
import { useLocation } from 'react-router-dom';
import { connect as unistoreConnect } from '../../store/unistore/combined/react';
import PropTypes from 'prop-types';

const Overrides = ({ updateColors }) => {
    const location = useLocation();
    useEffect(() => {
        if (location && location.search.length > 0) {
            const params = new URLSearchParams(location.search.slice(1));
            const primaryColor = params.get('primaryColor');
            const secondaryColor = params.get('secondaryColor');

            if (primaryColor && secondaryColor) {
                updateColors(primaryColor, secondaryColor);
            }
        }
    }, []);

    return null;
};

Overrides.propTypes = {
    updateColors: PropTypes.func.isRequired,
};

export default unistoreConnect([], overrideActions)(Overrides);
